import React from "react";
import { PageTitle } from "../../../../_metronic/layout/core";
import GenericReport from "../GenericReport";

const DailyJobCardVolumePage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[{ title: "Reports", path: "/reports", isActive: false }]}>
        Daily Job Card Volume
      </PageTitle>
      <GenericReport reportId={12} />
    </>
  );
};

export default DailyJobCardVolumePage;
